import { processUrl } from '@/utils/url/url.helper';

export const AppRoutesPaths = {
  BASE: '/',

  // ------------------- TOOLS --------------------------
  TOOLS_ROUTE: '/tools',
  HUBSPOT_SYNC_ROUTE: '/hubspot-sync',
  HUBSPOT_ERROR_LOG_ROUTE: '/hubspot-errors',
  HUBSPOT_BOOKING_ROUTE: '/book-a-meeting',
  FIND_USER_ROUTE: '/find-user',

  // ------------------- ACCOUNTS --------------------------
  ACCOUNTS_ROUTE: '/accounts',
  ACCOUNT_ROUTE: '/account',
  ACCOUNTS_CREATE_ROUTE: '/accounts/create',
  ACCOUNTS_UPDATE_ROUTE: '/accounts/edit/:id',
  ACCOUNT_INTEGRATIONS_ROUTE: '/account/integrations',
  ACCOUNT_INTEGRATIONS_MICROSOFT_ROUTE: '/account/integrations/microsoft',
  ACCOUNT_INTEGRATIONS_GOOGLE_ROUTE: '/account/integrations/google',
  ACCOUNTS_INTERNAL_ROUTE: '/accounts/internal/:id',
  ACCOUNTS_INTERNAL_GO_PHISH_ROUTE: '/accounts/internal/:id/gophish',
  ACCOUNTS_INTERNAL_HUBSPOT_ROUTE: '/accounts/integrations/:id/hubspot',
  ACCOUNTS_INTEGRATIONS_ROUTE: '/accounts/integrations/:id',
  ACCOUNTS_INTEGRATIONS_MICROSOFT_ROUTE: '/accounts/integrations/:id/microsoft',
  ACCOUNTS_INTEGRATIONS_GOOGLE_ROUTE: '/accounts/integrations/:id/google',
  ACCOUNT_AZURE_AD_ROUTE: '/accounts/azure-ad/:id',
  ACCOUNT_SAML_CONFIG_ROUTE: '/accounts/saml-config/:id',
  ACCOUNT_SSO_ROUTE: '/accounts/sso/:id',
  ACCOUNT_COURSES_ROUTE: '/accounts/content/:id',
  ACCOUNT_SECURITY_DOCUMENTS_ROUTE: '/accounts/documents/:id',
  ACCOUNTS_DATA_CONTROL_ROUTE: '/accounts/data-control/:id',
  ACCOUNT_DATA_CONTROL_ROUTE: '/account/data-control',
  ACCOUNTS_EMAILS_AND_DELIVERY_ROUTE: '/accounts/emails-and-delivery/:id',
  ACCOUNT_EMAILS_AND_DELIVERY_ROUTE: '/account/emails-and-delivery',
  ACCOUNT_DOMAIN_VERIFICATION_ROUTE: '/domain-verification/:token',
  ACCOUNTS_SECURITY_PROFILE_ROUTE: '/accounts/security-profile-quiz/:id',
  ACCOUNT_SECURITY_PROFILE_ROUTE: '/account/security-profile-quiz',
  ACCOUNT_FEATURE_FLAGS_ROUTE: '/accounts/features/:id',
  ACCOUNTS_API_ROUTE: '/accounts/api/:id',
  ACCOUNT_API_ROUTE: '/account/api',
  ACCOUNTS_TRAINING_SETTINGS_ROUTE: '/accounts/training-settings/:id',
  ACCOUNT_TRAINING_SETTINGS_ROUTE: '/account/training-settings',
  ACCOUNTS_ROLES_ACCESS_ROUTE: '/accounts/roles-access/:id',
  ACCOUNT_ROLES_ACCESS_ROUTE: '/account/roles-access',
  ACCOUNTS_ROLES_ACCESS_CREATE_ROUTE: '/accounts/roles-access/:id/role',
  ACCOUNT_ROLES_ACCESS_CREATE_ROUTE: '/account/roles-access/role',
  ACCOUNTS_ROLES_ACCESS_EDIT_ROUTE: '/accounts/roles-access/:id/role/:roleId',
  ACCOUNT_ROLES_ACCESS_EDIT_ROUTE: '/account/roles-access/role/:roleId',
  ACCOUNT_ERRORS_ROUTE: '/account/errors',
  // ------------------- RESELLERS --------------------------
  RESELLERS_ROUTE: '/resellers',
  RESELLERS_CREATE_ROUTE: '/resellers/create',
  RESELLERS_EDIT_ROUTE: '/resellers/edit/:id',
  RESELLERS_ACCOUNTS_ROUTE: '/resellers/:id/accounts',
  RESELLERS_SYSTEM_ROUTE: '/resellers/system',

  // ------------------- USERS --------------------------
  USERS_ROUTE: '/users',
  USERS_CREATE_ROUTE: '/users/create',
  USERS_EDIT_ROUTE: '/users/edit/:id',
  USERS_COURSES_ROUTE: '/users/content/:id',
  USERS_DOCUMENTS_ROUTE: '/users/documents/:id',
  USERS_PROPERTIES_ROUTE: '/users/properties/:id',
  USERS_PHISHING_ROUTE: '/users/phishing/:id',

  // ------------------- GROUPS --------------------------
  GROUPS_ROUTE: '/groups',
  GROUPS_CREATE_ROUTE: '/groups/create',
  GROUPS_EDIT_ROUTE: '/groups/edit/:id',
  GROUPS_USERS_ROUTE: '/groups/edit/:id/users',

  // ------------------- BRANCHES --------------------------
  BRANCHES_ROUTE: '/branches',
  BRANCHES_CREATE_ROUTE: '/branches/create',
  BRANCHES_EDIT_ROUTE: '/branches/edit/:id',
  BRANCHES_USERS_ROUTE: '/branches/edit/:id/users',
  BRANCHES_USERS_IMPORT_ROUTE: '/branches/edit/:id/import',

  // ------------------- CAMPAIGNS --------------------------
  PHISHING_ANALYTICS_ROUTE: '/phishing-analytics',
  PHISHING_INTRO_ROUTE: '/phishing-intro',
  PHISHING_SIMULATIONS_ROUTE: '/phishing-simulations',
  CAMPAIGNS_ROUTE: '/campaigns',
  CAMPAIGNS_CREATE_ROUTE: '/campaigns/create',
  CAMPAIGNS_EDIT_ROUTE: '/campaigns/edit/:id',
  CAMPAIGNS_COPY_ROUTE: '/campaigns/copy/:id',
  CAMPAIGNS_REPORT_ROUTE: '/campaigns/report/:id',
  CAMPAIGNS_MASTER_TEMPLATE_REPORT_ROUTE:
    '/campaigns/report/master-template/:masterTemplateId',
  CAMPAIGNS_CATALOGUE_ROUTE: '/campaigns/catalogue',
  CAMPAIGNS_CATALOGUE_V2_ROUTE: '/campaigns/catalogue-v2',

  // ------------------- LANDING PAGE TEMPLATES --------------------------
  LANDING_PAGE_TEMPLATES_PREDEFINED_ROUTE: '/landing-page-templates/predefined',
  LANDING_PAGE_TEMPLATES_CUSTOM_ROUTE: '/landing-page-templates/custom',
  LANDING_PAGE_TEMPLATES_CREATE_ROUTE: '/landing-page-templates/create',
  LANDING_PAGE_TEMPLATES_UPDATE_ROUTE: '/landing-page-templates/edit/:id',

  // ------------------- REDIRECT PAGE TEMPLATES --------------------------
  REDIRECT_PAGE_TEMPLATES_PREDEFINED_ROUTE:
    '/redirect-page-templates/predefined',
  REDIRECT_PAGE_TEMPLATES_CUSTOM_ROUTE: '/redirect-page-templates/custom',
  REDIRECT_PAGE_TEMPLATES_CREATE_ROUTE: '/redirect-page-templates/create',
  REDIRECT_PAGE_TEMPLATES_UPDATE_ROUTE: '/redirect-page-templates/edit/:id',

  // ------------------- EMAIL TEMPLATES --------------------------
  EMAIL_TEMPLATES_PREDEFINED_ROUTE: '/email-templates/predefined',
  EMAIL_TEMPLATES_CUSTOM_ROUTE: '/email-templates/custom',
  EMAIL_TEMPLATES_CREATE_ROUTE: '/email-templates/create',
  EMAIL_TEMPLATES_UPDATE_ROUTE: '/email-templates/edit/:id',

  // ------------------- SENDER PROFILES --------------------------
  SENDER_PROFILES_PREDEFINED_ROUTE: '/sender-profiles/predefined',
  SENDER_PROFILES_CUSTOM_ROUTE: '/sender-profiles/custom',
  SENDER_PROFILES_CREATE_ROUTE: '/sender-profiles/create',
  SENDER_PROFILES_EDIT_ROUTE: '/sender-profiles/edit/:id',

  // ------------------- PHISHING GLOBAL SETTINGS --------------------------
  PHISHING_GLOBAL_SETTINGS_ROUTE: '/phishing-global-settings',

  // ------------------- CAMPAIGN MASTER TEMPLATES --------------------------
  CAMPAIGN_MASTER_TEMPLATES_ROUTE: '/campaign-master-templates',
  CAMPAIGN_MASTER_TEMPLATES_CREATE_ROUTE: '/campaign-master-templates/create',
  CAMPAIGN_MASTER_TEMPLATES_EDIT_ROUTE: '/campaign-master-templates/:id/edit',

  // ------------------- USER PROFILE -----------------------------
  PROFILE_SETTINGS_ROUTE: '/profile/settings',
  LEARNER_PROFILE_SETTINGS_ROUTE: '/learner/profile/settings',

  // ------------------- DASHBOARDS --------------------------
  ADMIN_DASHBOARD_ROUTE: '/dashboard/admin',
  LEARNER_DASHBOARD_ACTIVE_ROUTE: '/dashboard/learner/to-do',
  LEARNER_DASHBOARD_COMPLETED_ROUTE: '/dashboard/learner/completed',
  LEARNER_DASHBOARD_MATERIALS_RESOURCES_ROUTE:
    '/dashboard/learner/materials/resources',
  LEARNER_DASHBOARD_MATERIALS_TODO_ROUTE: '/dashboard/learner/materials/to-do',
  LEARNER_DASHBOARD_MATERIALS_COMPLETED_ROUTE:
    '/dashboard/learner/materials/completed',
  LEARNER_PHISHING_ROUTE: '/dashboard/learner/phishing',
  LEARNER_PHISHING_DETAIL_ROUTE: '/dashboard/learner/phishing/:campaignId',

  // ------------------- ADMIN TASKS --------------------------
  ADMIN_TASKS_ROUTE: '/admin-tasks',

  // ------------------- NOT FOUND --------------------------
  NOT_FOUND_ROUTE: '/not-found',

  // ------------------- UNAUTHORIZED --------------------------
  UNAUTHORIZED_ROUTE: '/unauthorized',

  // ------------------- LOGIN --------------------------
  LOGIN_ROUTE: '/login',

  // ------------------- SYSTEM EMAILS --------------------------
  SYSTEM_EMAILS_TEMPLATES_ROUTE: '/system-emails/templates',
  SYSTEM_EMAILS_TEMPLATES_CREATE_ROUTE: '/system-emails/templates/create',
  SYSTEM_EMAILS_TEMPLATES_EDIT_ROUTE: '/system-emails/templates/edit/:id',
  SYSTEM_EMAILS_TYPES_CONFIGS_ROUTE: '/system-emails/configs',
  SYSTEM_EMAILS_TYPES_CONFIGS_CREATE_ROUTE: '/system-emails/configs/create',
  SYSTEM_EMAILS_TYPES_CONFIGS_EDIT_ROUTE: '/system-emails/configs/edit/:id',
  SYSTEM_EMAILS_SENDING_CONFIGS_ROUTE: '/system-emails/sending-configs',

  // ------------------- LOGIN/LOGOUT ---------------------------------
  COMPLETE_KEYCLOAK_SIGN_IN_ROUTE: '/complete-sign-in',
  SILENT_RENEW_CALLBACK_ROUTE: '/silent-renew-callback',
  LOGOUT: '/logout',

  // ------------------- COURSES --------------------------
  COURSES_ROUTE: '/content',
  CONTENT_ANALYTICS_ROUTE: '/awareness-training-analytics',
  COURSES_CREATE_ROUTE: '/content/create/:id?',
  COURSES_CREATE_BLANK_ROUTE: '/content/create',
  COURSES_CONTENT_ROUTE: '/content/:id/details',
  COURSES_SCHEDULE_ROUTE: '/content/:id/schedule',
  COURSES_ACCOUNTS_ROUTE: '/content/:id/accounts',
  COURSES_BRANCHES_ROUTE: '/content/:id/branches',
  COURSES_GROUPS_ROUTE: '/content/:id/groups',
  COURSES_USERS_ROUTE: '/content/:id/users',
  COURSES_SCORM_PREVIEW_ROUTE: '/content/:id/scorm-preview',
  COURSES_ANALYTICS_ROUTE: '/content/:id/analytics',
  COURSES_RESULTS_ROUTE: '/content/:courseId/results/:quizId',
  COURSES_CHANGES_ROUTE: '/content/:id/changes',
  COURSES_CUSTOMIZE_ROUTE: '/content/:id/customize',
  COURSES_TRANSLATE_ROUTE: '/content/:id/translate',
  COURSES_REPLACE_SCHEDULED_CONTENT_ROUTE:
    '/content/:customizedCourseId/replace-scheduled-content',

  ACCOUNT_COURSE_EVENT_LOG: '/enrollment/event-log',
  ACCOUNT_COURSE_PLANNER_ROUTE: '/enrollment/training-planner',

  // ------------------- MATERIALS --------------------------
  RESOURCES_ROUTE: '/resources',
  RESOURCES_CREATE_ROUTE: '/resources/create',
  RESOURCES_EDIT_ROUTE: '/resources/edit/:id',
  RESOURCES_SCHEDULE_ROUTE: '/resources/:id/schedule',
  RESOURCES_ACCOUNTS_ROUTE: '/resources/:id/accounts',
  RESOURCES_USERS_ROUTE: '/resources/:id/users',
  CUSTOM_MATERIALS_EDIT_ROUTE: '/custom-materials/edit/:id',
  CUSTOM_MATERIALS_SCHEDULE_ROUTE: '/custom-materials/:id/schedule',
  CUSTOM_MATERIALS_USERS_ROUTE: '/custom-materials/:id/users',
  CUSTOM_MATERIALS_PREVIEW_ROUTE: '/custom-materials/:id/preview',
  MATERIALS_BRANCHES_ROUTE: '/custom-materials/:id/branches',
  MATERIALS_GROUPS_ROUTE: '/custom-materials/:id/groups',
  POSTERS_ROUTE: '/resources/posters',
  POSTERS_COURSE_ROUTE: '/resources/posters/course-posters',
  POSTERS_CYBERSECURITY_ROUTE: '/resources/posters/cybersecurity',
  POSTERS_GDPR_ROUTE: '/resources/posters/gdpr',
  POSTERS_INFO_SCREEN_ROUTE: '/resources/posters/info-screen',
  POSTERS_INFOGRAPHICS_ROUTE: '/resources/posters/infographics',
  POSTER_CREATE_ROUTE: '/resources/posters/create',
  POSTER_EDIT_ROUTE: '/resources/posters/edit/:id',
  POSTER_ACCOUNTS_ROUTE: '/resources/posters/:id/accounts',
  DOCUMENT_VIEW_ROUTE: '/policies-and-documents/:id/view/:attemptId',

  ACCOUNT_DOCUMENTS_SCHEDULE_ROUTE: '/policies-and-documents-schedule',

  // ------------------- LEARNER COURSES ---------------------------------
  COURSE_INFO_ROUTE: '/courses/:id',
  CONTENT_INFO_ROUTE: '/content/:id',
  COURSE_PLAY_ROUTE: '/courses/:id/play/:attemptId',
  CONTENT_PLAY_ROUTE: '/content/:id/play/:attemptId',

  // ------------------- SECURITY CULTURE ---------------------------------
  SECURITY_CULTURE_ROUTE: '/security-culture-surveys',
  SURVEY_ROUTE: '/survey',
  TAKE_SURVEY_ROUTE: '/survey/:surveyId/:token?',
  SECURITY_CULTURE_UPLOAD_SURVEY_ROUTE:
    '/security-culture-surveys/survey/upload',
  SECURITY_CULTURE_EDIT_SURVEY_ROUTE:
    '/security-culture-surveys/survey/edit/:id',
  SECURITY_CULTURE_SEND_SURVEY_ROUTE: '/security-culture/invite',
  SECURITY_CULTURE_SEND_SURVEY_V2_ROUTE: '/security-culture/schedule-survey',
  SECURITY_CULTURE_SURVEY_PLANNER_ROUTE: '/security-culture/survey-planner',
  SECURITY_CULTURE_SURVEY_ID_ROUTE:
    '/security-culture-survey?surveyId=:surveyId',
  SECURITY_CULTURE_SURVEY_ROUTE: '/security-culture-survey',
  SECURITY_CULTURE_FEEDBACK_ROUTE:
    '/security-culture-survey/:surveyId/feedback',
  SECURITY_CULTURE_CATEGORY_ROUTE:
    '/security-culture-survey/:surveyId/category/:categoryName',

  // ------------------- REPORTS ---------------------------------
  REPORTS_SUMMARY_ROUTE: '/reports-summary',
  REPORTS_AWARENESS_ROUTE: '/reports-awareness',

  // ------------------- FEATURE FLAGS ---------------------------------
  FEATURES_ROUTE: '/features',
};

export enum RedirectPathsEnum {
  BASE = 'BASE',

  // ------------------- TOOLS --------------------------
  HUBSPOT_SYNC = 'HUBSPOT_SYNC',
  HUBSPOT_ERROR_LOG = 'HUBSPOT_ERROR_LOG',
  HUBSPOT_BOOKING = 'HUBSPOT_BOOKING',
  FIND_USER = 'FIND_USER',

  // ------------------- ACCOUNTS --------------------------
  ACCOUNTS = 'ACCOUNTS',
  ACCOUNT = 'ACCOUNT',
  CREATE_ACCOUNT = 'CREATE_ACCOUNT',
  EDIT_ACCOUNT = 'EDIT_ACCOUNT',
  ACCOUNT_INTEGRATIONS = 'ACCOUNT_INTEGRATIONS',
  ACCOUNT_INTEGRATIONS_MICROSOFT = 'ACCOUNT_INTEGRATIONS_MICROSOFT',
  ACCOUNT_INTEGRATIONS_GOOGLE = 'ACCOUNT_INTEGRATIONS_GOOGLE',
  ACCOUNTS_INTERNAL = 'ACCOUNTS_INTERNAL',
  ACCOUNTS_INTERNAL_GO_PHISH = 'ACCOUNTS_INTERNAL_GO_PHISH',
  ACCOUNTS_INTERNAL_HUBSPOT = 'ACCOUNTS_INTERNAL_HUBSPOT',
  ACCOUNTS_INTEGRATIONS = 'ACCOUNTS_INTEGRATIONS',
  ACCOUNTS_INTEGRATIONS_MICROSOFT = 'ACCOUNTS_INTEGRATIONS_MICROSOFT',
  ACCOUNTS_INTEGRATIONS_GOOGLE = 'ACCOUNTS_INTEGRATIONS_GOOGLE',
  ACCOUNT_AZURE_AD = 'ACCOUNT_AZURE_AD',
  ACCOUNT_MIGRATION = 'ACCOUNT_MIGRATION',
  ACCOUNT_SAML_CONFIG = 'ACCOUNT_SAML_CONFIG',
  ACCOUNT_SSO = 'ACCOUNT_SSO',
  ACCOUNT_COURSES = 'ACCOUNT_COURSES',
  ACCOUNT_SECURITY_DOCUMENTS = 'ACCOUNT_SECURITY_DOCUMENTS',
  ACCOUNT_DATA_CONTROL = 'ACCOUNT_DATA_CONTROL',
  ACCOUNTS_DATA_CONTROL = 'ACCOUNTS_DATA_CONTROL',
  ACCOUNT_EMAILS_AND_DELIVERY = 'ACCOUNT_EMAILS_AND_DELIVERY',
  ACCOUNTS_EMAILS_AND_DELIVERY = 'ACCOUNTS_EMAILS_AND_DELIVERY',
  ACCOUNT_EMAILS_AND_DELIVERY_DOMAINS = 'ACCOUNT_EMAILS_AND_DELIVERY_DOMAINS',
  ACCOUNTS_EMAILS_AND_DELIVERY_DOMAINS = 'ACCOUNTS_EMAILS_AND_DELIVERY_DOMAINS',
  ACCOUNT_DOMAIN_VERIFICATION = 'ACCOUNT_DOMAIN_VERIFICATION',
  ACCOUNT_SECURITY_PROFILE = 'ACCOUNT_SECURITY_PROFILE',
  ACCOUNTS_SECURITY_PROFILE = 'ACCOUNTS_SECURITY_PROFILE',
  ACCOUNT_FEATURE_FLAGS = 'ACCOUNT_FEATURE_FLAGS',
  ACCOUNT_ERRORS = 'ACCOUNT_ERRORS',
  ACCOUNT_TRAINING_SETTINGS = 'ACCOUNT_TRAINING_SETTINGS',
  ACCOUNTS_TRAINING_SETTINGS = 'ACCOUNTS_TRAINING_SETTINGS',
  ACCOUNT_API = 'ACCOUNT_API',
  ACCOUNTS_API = 'ACCOUNTS_API',
  ACCOUNT_ROLES_ACCESS = 'ACCOUNT_ROLES_ACCESS',
  ACCOUNTS_ROLES_ACCESS = 'ACCOUNTS_ROLES_ACCESS',
  ACCOUNT_ROLES_ACCESS_CREATE = 'ACCOUNT_ROLES_ACCESS_CREATE',
  ACCOUNTS_ROLES_ACCESS_CREATE = 'ACCOUNTS_ROLES_ACCESS_CREATE',
  ACCOUNT_ROLES_ACCESS_EDIT = 'ACCOUNT_ROLES_ACCESS_EDIT',
  ACCOUNTS_ROLES_ACCESS_EDIT = 'ACCOUNTS_ROLES_ACCESS_EDIT',
  // ------------------- RESELLERS --------------------------
  RESELLERS = 'RESELLERS',
  CREATE_RESELLERS = 'CREATE_RESELLERS',
  EDIT_RESELLERS = 'EDIT_RESELLERS',
  RESELLERS_ACCOUNTS = 'RESELLERS_ACCOUNTS',
  RESELLERS_SYSTEM = 'RESELLERS_SYSTEM',

  // ------------------- USERS --------------------------
  USERS = 'USERS',
  USERS_CREATE = 'USERS_CREATE',
  USERS_EDIT = 'USERS_EDIT',
  USERS_COURSES = 'USERS_COURSES',
  USERS_DOCUMENTS = 'USERS_DOCUMENTS',
  USERS_PROPERTIES = 'USERS_PROPERTIES',
  USERS_PHISHING = 'USERS_PHISHING',

  // ------------------- GROUPS --------------------------
  GROUPS = 'GROUPS',
  GROUPS_CREATE = 'GROUPS_CREATE',
  GROUPS_EDIT = 'GROUPS_EDIT',
  GROUPS_USERS = 'GROUPS_USERS',

  // ------------------- BRANCHES --------------------------
  BRANCHES = 'BRANCHES',
  BRANCHES_CREATE = 'BRANCHES_CREATE',
  BRANCHES_EDIT = 'BRANCHES_EDIT',
  BRANCHES_USERS = 'BRANCHES_USERS',
  BRANCHES_USERS_IMPORT = 'BRANCHES_USERS_IMPORT',

  // ------------------- CAMPAIGNS --------------------------
  PHISHING_ANALYTICS = 'PHISHING_ANALYTICS',
  PHISHING_INTRO = 'PHISHING_INTRO',
  PHISHING_SIMULATIONS = 'PHISHING_SIMULATIONS',
  CAMPAIGNS = 'CAMPAIGNS',
  CAMPAIGNS_CREATE = 'CAMPAIGNS_CREATE',
  CAMPAIGNS_EDIT = 'CAMPAIGNS_EDIT',
  CAMPAIGNS_COPY = 'CAMPAIGNS_COPY',
  CAMPAIGNS_REPORT = 'CAMPAIGNS_REPORT',
  CAMPAIGNS_MASTER_TEMPLATE_REPORT = 'CAMPAIGNS_MASTER_TEMPLATE_REPORT',
  CAMPAIGNS_CATALOGUE = 'CAMPAIGNS_CATALOGUE',
  CAMPAIGNS_CATALOGUE_V2 = 'CAMPAIGNS_CATALOGUE_V2',
  PHISHING_GLOBAL_SETTINGS = 'PHISHING_GLOBAL_SETTINGS',
  CAMPAIGN_MASTER_TEMPLATES = 'CAMPAIGN_MASTER_TEMPLATES',
  CAMPAIGN_MASTER_TEMPLATES_CREATE = 'CAMPAIGN_MASTER_TEMPLATES_CREATE',
  CAMPAIGN_MASTER_TEMPLATES_EDIT = 'CAMPAIGN_MASTER_TEMPLATES_EDIT',

  // ------------------- PAGE TEMPLATES --------------------------
  LANDING_PAGE_TEMPLATES_PREDEFINED = 'LANDING_PAGE_TEMPLATES_PREDEFINED',
  LANDING_PAGE_TEMPLATES_CUSTOM = 'LANDING_PAGE_TEMPLATES_CUSTOM',
  LANDING_PAGE_TEMPLATES_CREATE = 'LANDING_PAGE_TEMPLATES_CREATE',
  LANDING_PAGE_TEMPLATES_UPDATE = 'LANDING_PAGE_TEMPLATES_UPDATE',

  // ------------------- REDIRECT PAGE TEMPLATES --------------------------
  REDIRECT_PAGE_TEMPLATES_PREDEFINED = 'REDIRECT_PAGE_TEMPLATES_PREDEFINED',
  REDIRECT_PAGE_TEMPLATES_CUSTOM = 'REDIRECT_PAGE_TEMPLATES_CUSTOM',
  REDIRECT_PAGE_TEMPLATES_CREATE = 'REDIRECT_PAGE_TEMPLATES_CREATE',
  REDIRECT_PAGE_TEMPLATES_UPDATE = 'REDIRECT_PAGE_TEMPLATES_UPDATE',

  // ------------------- EMAIL TEMPLATES --------------------------
  EMAIL_TEMPLATES_PREDEFINED = 'EMAIL_TEMPLATES_PREDEFINED',
  EMAIL_TEMPLATES_CUSTOM = 'EMAIL_TEMPLATES_CUSTOM',
  EMAIL_TEMPLATES_CREATE = 'EMAIL_TEMPLATES_CREATE',
  EMAIL_TEMPLATES_UPDATE = 'EMAIL_TEMPLATES_UPDATE',

  // ------------------- SENDER PROFILES --------------------------
  SENDER_PROFILES_PREDEFINED = 'SENDER_PROFILES_PREDEFINED',
  SENDER_PROFILES_CUSTOM = 'SENDER_PROFILES_CUSTOM',
  SENDER_PROFILES_CREATE = 'SENDER_PROFILES_CREATE',
  SENDER_PROFILES_EDIT = 'SENDER_PROFILES_EDIT',

  // ------------------- USER SETTINGS -----------------------------
  PROFILE_SETTINGS = 'PROFILE_SETTINGS',
  LEARNER_PROFILE_SETTINGS = 'LEARNER_PROFILE_SETTINGS',

  // ------------------- DASHBOARDS --------------------------
  ADMIN_DASHBOARD = 'ADMIN_DASHBOARD',
  LEARNER_DASHBOARD_ACTIVE = 'LEARNER_DASHBOARD_ACTIVE',
  LEARNER_DASHBOARD_COMPLETED = 'LEARNER_DASHBOARD_COMPLETED',
  LEARNER_DASHBOARD_MATERIALS_RESOURCES = 'LEARNER_DASHBOARD_MATERIALS_RESOURCES',
  LEARNER_DASHBOARD_MATERIALS_TODO = 'LEARNER_DASHBOARD_MATERIALS_TODO',
  LEARNER_DASHBOARD_MATERIALS_COMPLETED = 'LEARNER_DASHBOARD_MATERIALS_COMPLETED',
  LEARNER_PHISHING = 'LEARNER_PHISHING',
  LEARNER_PHISHING_DETAIL = 'LEARNER_PHISHING_DETAIL',

  // ------------------- ADMIN TASKS --------------------------
  ADMIN_TASKS = 'ADMIN_TASKS',

  // ------------------- NOT FOUND --------------------------
  NOT_FOUND = 'NOT_FOUND',

  // ------------------- UNAUTHORIZED --------------------------
  UNAUTHORIZED = 'UNAUTHORIZED',

  // ------------------- LOGIN --------------------------
  LOGIN = 'LOGIN',

  // ------------------- FEATURE FLAGS --------------------------
  FEATURES = 'FEATURES',

  // ------------------- SYSTEM SETTINGS --------------------------
  SYSTEM_EMAILS_TEMPLATES = 'SYSTEM_EMAILS_TEMPLATES',
  SYSTEM_EMAILS_TEMPLATES_CREATE = 'SYSTEM_EMAILS_TEMPLATES_CREATE',
  SYSTEM_EMAILS_TEMPLATES_EDIT = 'SYSTEM_EMAILS_TEMPLATES_EDIT',
  SYSTEM_EMAILS_TYPES_CONFIGS = 'SYSTEM_EMAILS_TYPES_CONFIGS',
  SYSTEM_EMAILS_TYPES_CONFIGS_CREATE = 'SYSTEM_EMAILS_TYPES_CONFIGS_CREATE',
  SYSTEM_EMAILS_TYPES_CONFIGS_EDIT = 'SYSTEM_EMAILS_TYPES_CONFIGS_EDIT',
  SYSTEM_EMAILS_SENDING_CONFIGS = 'SYSTEM_EMAILS_SENDING_CONFIGS',

  // ------------------- LOGIN/LOGOUT ---------------------------------
  LOGOUT = 'LOGOUT',

  // ------------------- COURSES --------------------------
  COURSES = 'COURSES',
  CONTENT_ANALYTICS = 'CONTENT_ANALYTICS',
  COURSES_CREATE = 'COURSES_CREATE',
  COURSES_CONTENT = 'COURSES_CONTENT',
  COURSES_SCHEDULE = 'COURSES_SCHEDULE',
  COURSES_ACCOUNTS = 'COURSES_ACCOUNTS',
  COURSES_BRANCHES = 'COURSES_BRANCHES',
  COURSES_GROUPS = 'COURSES_GROUPS',
  COURSES_USERS = 'COURSES_USERS',
  COURSES_SCORM_PREVIEW = 'COURSES_SCORM_PREVIEW',
  COURSES_ANALYTICS = 'COURSES_ANALYTICS',
  COURSES_RESULTS = 'COURSES_RESULTS',
  COURSES_CHANGES = 'COURSES_CHANGES',
  COURSES_CUSTOMIZE = 'COURSES_CUSTOMIZE',
  COURSES_REPLACE_SCHEDULED_CONTENT = 'COURSES_REPLACE_SCHEDULED_CONTENT',
  ACCOUNT_COURSE_SCHEDULE = 'ACCOUNT_COURSE_SCHEDULE',
  ACCOUNT_COURSE_PLANNER = 'ACCOUNT_COURSE_PLANNER',
  COURSES_TRANSLATE = 'COURSES_TRANSLATE',

  // ------------------- MATERIALS --------------------------

  RESOURCES = 'RESOURCES',
  RESOURCES_CREATE = 'RESOURCES_CREATE',
  RESOURCES_EDIT = 'RESOURCES_EDIT',
  RESOURCES_SCHEDULE = 'RESOURCES_SCHEDULE',
  RESOURCES_ACCOUNTS = 'RESOURCES_ACCOUNTS',
  RESOURCES_USERS = 'RESOURCES_USERS',
  CUSTOM_MATERIALS_EDIT = 'CUSTOM_MATERIALS_EDIT',
  CUSTOM_MATERIALS_SCHEDULE = 'CUSTOM_MATERIALS_SCHEDULE',
  CUSTOM_MATERIALS_USERS = 'CUSTOM_MATERIALS_USERS',
  CUSTOM_MATERIALS_PREVIEW = 'CUSTOM_MATERIALS_PREVIEW',
  MATERIALS_BRANCHES = 'MATERIALS_BRANCHES',
  MATERIALS_GROUPS = 'MATERIALS_GROUPS',
  POSTERS = 'POSTERS',
  POSTERS_COURSE = 'POSTERS_COURSE',
  POSTERS_CYBERSECURITY = 'POSTERS_CYBERSECURITY',
  POSTERS_GDPR = 'POSTERS_GDPR',
  POSTERS_INFO_SCREEN = 'POSTERS_INFO_SCREEN',
  POSTERS_INFOGRAPHICS = 'POSTERS_INFOGRAPHICS',
  POSTER_CREATE = 'POSTER_CREATE',
  POSTER_EDIT = 'POSTER_EDIT',
  POSTER_ACCOUNTS = 'POSTER_ACCOUNTS',

  ACCOUNT_DOCUMENTS_SCHEDULE = 'ACCOUNT_DOCUMENTS_SCHEDULE',

  DOCUMENT_VIEW = 'DOCUMENT_VIEW',

  // ------------------- SCORM COURSES ---------------------------------
  COURSE_INFO = 'COURSE_INFO',
  COURSE_PLAY = 'COURSE_PLAY',
  CONTENT_INFO = 'CONTENT_INFO',
  CONTENT_PLAY = 'CONTENT_PLAY',

  // ------------------- SECURITY CULTURE ---------------------------------
  SECURITY_CULTURE = 'SECURITY_CULTURE',
  SURVEY = 'SURVEY',
  TAKE_SURVEY = 'TAKE_SURVEY',
  SECURITY_CULTURE_SEND_SURVEY = 'SECURITY_CULTURE_SEND_SURVEY',
  SECURITY_CULTURE_SEND_SURVEY_V2 = 'SECURITY_CULTURE_SEND_SURVEY_V2',
  SECURITY_CULTURE_SURVEY_PLANNER = 'SECURITY_CULTURE_SURVEY_PLANNER',
  SECURITY_CULTURE_UPLOAD_SURVEY = 'SECURITY_CULTURE_UPLOAD_SURVEY',
  SECURITY_CULTURE_EDIT_SURVEY = 'SECURITY_CULTURE_EDIT_SURVEY',
  SECURITY_CULTURE_SURVEY = 'SECURITY_CULTURE_SURVEY',
  SECURITY_CULTURE_FEEDBACK = 'SECURITY_CULTURE_FEEDBACK',
  SECURITY_CULTURE_CATEGORY = 'SECURITY_CULTURE_CATEGORY',

  // ------------------- REPORTS ---------------------------------
  REPORTS_SUMMARY = 'REPORTS_SUMMARY',
  REPORTS_AWARENESS = 'REPORTS_AWARENESS',
}

export const RedirectPaths = {
  [RedirectPathsEnum.BASE]: AppRoutesPaths.BASE,
  // ------------------- TOOLS --------------------------
  [RedirectPathsEnum.FIND_USER]: () => AppRoutesPaths.FIND_USER_ROUTE,

  // ------------------- ACCOUNTS --------------------------
  [RedirectPathsEnum.ACCOUNTS]: () => AppRoutesPaths.ACCOUNTS_ROUTE,
  [RedirectPathsEnum.ACCOUNT]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNT_ROUTE, { id }),
  [RedirectPathsEnum.CREATE_ACCOUNT]: () =>
    AppRoutesPaths.ACCOUNTS_CREATE_ROUTE,
  [RedirectPathsEnum.EDIT_ACCOUNT]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNTS_UPDATE_ROUTE, { id }),
  [RedirectPathsEnum.ACCOUNT_INTEGRATIONS]: () =>
    AppRoutesPaths.ACCOUNT_INTEGRATIONS_ROUTE,
  [RedirectPathsEnum.ACCOUNT_INTEGRATIONS_MICROSOFT]: () =>
    AppRoutesPaths.ACCOUNT_INTEGRATIONS_MICROSOFT_ROUTE,
  [RedirectPathsEnum.ACCOUNT_INTEGRATIONS_GOOGLE]: () =>
    AppRoutesPaths.ACCOUNT_INTEGRATIONS_GOOGLE_ROUTE,
  [RedirectPathsEnum.ACCOUNTS_INTERNAL]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNTS_INTERNAL_ROUTE, { id }),
  [RedirectPathsEnum.ACCOUNTS_INTERNAL_GO_PHISH]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNTS_INTERNAL_GO_PHISH_ROUTE, { id }),
  [RedirectPathsEnum.ACCOUNTS_INTERNAL_HUBSPOT]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNTS_INTERNAL_HUBSPOT_ROUTE, { id }),
  [RedirectPathsEnum.ACCOUNTS_INTEGRATIONS]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNTS_INTEGRATIONS_ROUTE, { id }),
  [RedirectPathsEnum.ACCOUNTS_INTEGRATIONS_MICROSOFT]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNTS_INTEGRATIONS_MICROSOFT_ROUTE, { id }),
  [RedirectPathsEnum.ACCOUNTS_INTEGRATIONS_GOOGLE]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNTS_INTEGRATIONS_GOOGLE_ROUTE, { id }),
  [RedirectPathsEnum.ACCOUNT_AZURE_AD]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNT_AZURE_AD_ROUTE, { id }),
  [RedirectPathsEnum.ACCOUNT_SAML_CONFIG]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNT_SAML_CONFIG_ROUTE, { id }),
  [RedirectPathsEnum.ACCOUNT_SSO]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNT_SSO_ROUTE, { id }),
  [RedirectPathsEnum.ACCOUNT_COURSES]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNT_COURSES_ROUTE, { id }),
  [RedirectPathsEnum.ACCOUNT_SECURITY_DOCUMENTS]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNT_SECURITY_DOCUMENTS_ROUTE, { id }),
  [RedirectPathsEnum.ACCOUNT_DATA_CONTROL]: () =>
    AppRoutesPaths.ACCOUNT_DATA_CONTROL_ROUTE,
  [RedirectPathsEnum.ACCOUNTS_DATA_CONTROL]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNTS_DATA_CONTROL_ROUTE, { id }),
  [RedirectPathsEnum.ACCOUNT_EMAILS_AND_DELIVERY]: () =>
    AppRoutesPaths.ACCOUNT_EMAILS_AND_DELIVERY_ROUTE,
  [RedirectPathsEnum.ACCOUNTS_EMAILS_AND_DELIVERY]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNTS_EMAILS_AND_DELIVERY_ROUTE, { id }),
  [RedirectPathsEnum.ACCOUNT_EMAILS_AND_DELIVERY_DOMAINS]: () =>
    `${AppRoutesPaths.ACCOUNT_EMAILS_AND_DELIVERY_ROUTE}#domain-verification`,
  [RedirectPathsEnum.ACCOUNTS_EMAILS_AND_DELIVERY_DOMAINS]: (id: string) =>
    `${processUrl(AppRoutesPaths.ACCOUNTS_EMAILS_AND_DELIVERY_ROUTE, {
      id,
    })}#domain-verification`,
  [RedirectPathsEnum.ACCOUNT_DOMAIN_VERIFICATION]: (token: string) =>
    processUrl(AppRoutesPaths.ACCOUNT_DOMAIN_VERIFICATION_ROUTE, { token }),
  [RedirectPathsEnum.ACCOUNT_SECURITY_PROFILE]: () =>
    AppRoutesPaths.ACCOUNT_SECURITY_PROFILE_ROUTE,
  [RedirectPathsEnum.ACCOUNTS_SECURITY_PROFILE]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNTS_SECURITY_PROFILE_ROUTE, { id }),
  [RedirectPathsEnum.HUBSPOT_SYNC]: () => AppRoutesPaths.HUBSPOT_SYNC_ROUTE,
  [RedirectPathsEnum.HUBSPOT_ERROR_LOG]: () =>
    AppRoutesPaths.HUBSPOT_ERROR_LOG_ROUTE,
  [RedirectPathsEnum.HUBSPOT_BOOKING]: () =>
    AppRoutesPaths.HUBSPOT_BOOKING_ROUTE,
  [RedirectPathsEnum.ACCOUNT_FEATURE_FLAGS]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNT_FEATURE_FLAGS_ROUTE, { id }),
  [RedirectPathsEnum.ACCOUNT_ERRORS]: () => AppRoutesPaths.ACCOUNT_ERRORS_ROUTE,
  [RedirectPathsEnum.ACCOUNT_TRAINING_SETTINGS]: () =>
    AppRoutesPaths.ACCOUNT_TRAINING_SETTINGS_ROUTE,
  [RedirectPathsEnum.ACCOUNTS_TRAINING_SETTINGS]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNTS_TRAINING_SETTINGS_ROUTE, { id }),
  [RedirectPathsEnum.ACCOUNT_API]: () => AppRoutesPaths.ACCOUNT_API_ROUTE,
  [RedirectPathsEnum.ACCOUNTS_API]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNTS_API_ROUTE, { id }),
  [RedirectPathsEnum.ACCOUNT_ROLES_ACCESS]: () =>
    AppRoutesPaths.ACCOUNT_ROLES_ACCESS_ROUTE,
  [RedirectPathsEnum.ACCOUNTS_ROLES_ACCESS]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNTS_ROLES_ACCESS_ROUTE, { id }),
  [RedirectPathsEnum.ACCOUNT_ROLES_ACCESS_CREATE]: () =>
    AppRoutesPaths.ACCOUNT_ROLES_ACCESS_CREATE_ROUTE,
  [RedirectPathsEnum.ACCOUNTS_ROLES_ACCESS_CREATE]: (id: string) =>
    processUrl(AppRoutesPaths.ACCOUNTS_ROLES_ACCESS_CREATE_ROUTE, { id }),
  [RedirectPathsEnum.ACCOUNT_ROLES_ACCESS_EDIT]: (roleId: string) =>
    processUrl(AppRoutesPaths.ACCOUNT_ROLES_ACCESS_EDIT_ROUTE, { roleId }),
  [RedirectPathsEnum.ACCOUNTS_ROLES_ACCESS_EDIT]: (
    id: string,
    roleId: string,
  ) =>
    processUrl(AppRoutesPaths.ACCOUNTS_ROLES_ACCESS_EDIT_ROUTE, { id, roleId }),
  //------------------- RESELLERS --------------------------
  [RedirectPathsEnum.RESELLERS]: () => AppRoutesPaths.RESELLERS_ROUTE,
  [RedirectPathsEnum.CREATE_RESELLERS]: () =>
    AppRoutesPaths.RESELLERS_CREATE_ROUTE,
  [RedirectPathsEnum.EDIT_RESELLERS]: (id: string) =>
    processUrl(AppRoutesPaths.RESELLERS_EDIT_ROUTE, { id }),
  [RedirectPathsEnum.RESELLERS_ACCOUNTS]: (id: string) =>
    processUrl(AppRoutesPaths.RESELLERS_ACCOUNTS_ROUTE, { id }),
  [RedirectPathsEnum.RESELLERS_SYSTEM]: () =>
    AppRoutesPaths.RESELLERS_SYSTEM_ROUTE,

  //------------------- USERS --------------------------
  [RedirectPathsEnum.USERS]: () => `${AppRoutesPaths.USERS_ROUTE}`,
  [RedirectPathsEnum.USERS_CREATE]: () =>
    `${AppRoutesPaths.USERS_CREATE_ROUTE}`,
  [RedirectPathsEnum.USERS_EDIT]: (id: string) =>
    processUrl(AppRoutesPaths.USERS_EDIT_ROUTE, { id }),
  [RedirectPathsEnum.USERS_COURSES]: (id: string) =>
    processUrl(AppRoutesPaths.USERS_COURSES_ROUTE, { id }),
  [RedirectPathsEnum.USERS_DOCUMENTS]: (id: string) =>
    processUrl(AppRoutesPaths.USERS_DOCUMENTS_ROUTE, { id }),
  [RedirectPathsEnum.USERS_PROPERTIES]: (id: string) =>
    processUrl(AppRoutesPaths.USERS_PROPERTIES_ROUTE, { id }),
  [RedirectPathsEnum.USERS_PHISHING]: (id: string) =>
    processUrl(AppRoutesPaths.USERS_PHISHING_ROUTE, { id }),

  // ------------------- GROUPS --------------------------
  [RedirectPathsEnum.GROUPS]: () => AppRoutesPaths.GROUPS_ROUTE,
  [RedirectPathsEnum.GROUPS_CREATE]: () => AppRoutesPaths.GROUPS_CREATE_ROUTE,
  [RedirectPathsEnum.GROUPS_EDIT]: (groupId: string) =>
    processUrl(AppRoutesPaths.GROUPS_EDIT_ROUTE, { id: groupId }),
  [RedirectPathsEnum.GROUPS_USERS]: (groupId: string) =>
    processUrl(AppRoutesPaths.GROUPS_USERS_ROUTE, { id: groupId }),

  // ------------------- BRANCHES --------------------------
  [RedirectPathsEnum.BRANCHES]: () => AppRoutesPaths.BRANCHES_ROUTE,
  [RedirectPathsEnum.BRANCHES_CREATE]: () =>
    AppRoutesPaths.BRANCHES_CREATE_ROUTE,
  [RedirectPathsEnum.BRANCHES_EDIT]: (id: string) =>
    processUrl(AppRoutesPaths.BRANCHES_EDIT_ROUTE, { id }),
  [RedirectPathsEnum.BRANCHES_USERS]: (id: string) =>
    processUrl(AppRoutesPaths.BRANCHES_USERS_ROUTE, { id }),
  [RedirectPathsEnum.BRANCHES_USERS_IMPORT]: (id: string) =>
    processUrl(AppRoutesPaths.BRANCHES_USERS_IMPORT_ROUTE, { id }),

  // ------------------- CAMPAIGNS --------------------------
  [RedirectPathsEnum.PHISHING_ANALYTICS]: () =>
    AppRoutesPaths.PHISHING_ANALYTICS_ROUTE,
  [RedirectPathsEnum.PHISHING_INTRO]: () => AppRoutesPaths.PHISHING_INTRO_ROUTE,
  [RedirectPathsEnum.PHISHING_SIMULATIONS]: () =>
    AppRoutesPaths.PHISHING_SIMULATIONS_ROUTE,
  [RedirectPathsEnum.CAMPAIGNS]: () => AppRoutesPaths.CAMPAIGNS_ROUTE,
  [RedirectPathsEnum.CAMPAIGNS_CREATE]: () =>
    AppRoutesPaths.CAMPAIGNS_CREATE_ROUTE,
  [RedirectPathsEnum.CAMPAIGNS_EDIT]: (id: string) =>
    processUrl(AppRoutesPaths.CAMPAIGNS_EDIT_ROUTE, { id }),
  [RedirectPathsEnum.CAMPAIGNS_COPY]: (id: string) =>
    processUrl(AppRoutesPaths.CAMPAIGNS_COPY_ROUTE, { id }),
  [RedirectPathsEnum.CAMPAIGNS_REPORT]: (id: string) =>
    processUrl(AppRoutesPaths.CAMPAIGNS_REPORT_ROUTE, { id }),
  [RedirectPathsEnum.CAMPAIGNS_MASTER_TEMPLATE_REPORT]: (
    masterTemplateId: string,
  ) =>
    processUrl(AppRoutesPaths.CAMPAIGNS_MASTER_TEMPLATE_REPORT_ROUTE, {
      masterTemplateId,
    }),
  [RedirectPathsEnum.CAMPAIGNS_CATALOGUE]: () =>
    AppRoutesPaths.CAMPAIGNS_CATALOGUE_ROUTE,
  [RedirectPathsEnum.CAMPAIGNS_CATALOGUE_V2]: () =>
    AppRoutesPaths.CAMPAIGNS_CATALOGUE_V2_ROUTE,

  // ------------------- PAGE TEMPLATES --------------------------
  [RedirectPathsEnum.LANDING_PAGE_TEMPLATES_PREDEFINED]: () =>
    AppRoutesPaths.LANDING_PAGE_TEMPLATES_PREDEFINED_ROUTE,
  [RedirectPathsEnum.LANDING_PAGE_TEMPLATES_CUSTOM]: () =>
    AppRoutesPaths.LANDING_PAGE_TEMPLATES_CUSTOM_ROUTE,
  [RedirectPathsEnum.LANDING_PAGE_TEMPLATES_CREATE]: () =>
    AppRoutesPaths.LANDING_PAGE_TEMPLATES_CREATE_ROUTE,
  [RedirectPathsEnum.LANDING_PAGE_TEMPLATES_UPDATE]: (id: string) =>
    processUrl(AppRoutesPaths.LANDING_PAGE_TEMPLATES_UPDATE_ROUTE, { id }),

  // ------------------- REDIRECT TEMPLATES --------------------------
  [RedirectPathsEnum.REDIRECT_PAGE_TEMPLATES_PREDEFINED]: () =>
    AppRoutesPaths.REDIRECT_PAGE_TEMPLATES_PREDEFINED_ROUTE,
  [RedirectPathsEnum.REDIRECT_PAGE_TEMPLATES_CUSTOM]: () =>
    AppRoutesPaths.REDIRECT_PAGE_TEMPLATES_CUSTOM_ROUTE,
  [RedirectPathsEnum.REDIRECT_PAGE_TEMPLATES_CREATE]: () =>
    AppRoutesPaths.REDIRECT_PAGE_TEMPLATES_CREATE_ROUTE,
  [RedirectPathsEnum.REDIRECT_PAGE_TEMPLATES_UPDATE]: (id: string) =>
    processUrl(AppRoutesPaths.REDIRECT_PAGE_TEMPLATES_UPDATE_ROUTE, { id }),

  // ------------------- EMAIL TEMPLATES --------------------------
  [RedirectPathsEnum.EMAIL_TEMPLATES_PREDEFINED]: () =>
    AppRoutesPaths.EMAIL_TEMPLATES_PREDEFINED_ROUTE,
  [RedirectPathsEnum.EMAIL_TEMPLATES_CUSTOM]: () =>
    AppRoutesPaths.EMAIL_TEMPLATES_CUSTOM_ROUTE,
  [RedirectPathsEnum.EMAIL_TEMPLATES_CREATE]: () =>
    AppRoutesPaths.EMAIL_TEMPLATES_CREATE_ROUTE,
  [RedirectPathsEnum.EMAIL_TEMPLATES_UPDATE]: (id: string) =>
    processUrl(AppRoutesPaths.EMAIL_TEMPLATES_UPDATE_ROUTE, { id }),

  //------------------- SENDER PROFILES --------------------------
  [RedirectPathsEnum.SENDER_PROFILES_PREDEFINED]: () =>
    `${AppRoutesPaths.SENDER_PROFILES_PREDEFINED_ROUTE}`,
  [RedirectPathsEnum.SENDER_PROFILES_CUSTOM]: () =>
    `${AppRoutesPaths.SENDER_PROFILES_CUSTOM_ROUTE}`,
  [RedirectPathsEnum.SENDER_PROFILES_CREATE]: () =>
    `${AppRoutesPaths.SENDER_PROFILES_CREATE_ROUTE}`,
  [RedirectPathsEnum.SENDER_PROFILES_EDIT]: (id: string) =>
    processUrl(AppRoutesPaths.SENDER_PROFILES_EDIT_ROUTE, { id }),

  //------------------- PHISHING GLOBAL SETTINGS --------------------------
  [RedirectPathsEnum.PHISHING_GLOBAL_SETTINGS]: () =>
    `${AppRoutesPaths.PHISHING_GLOBAL_SETTINGS_ROUTE}`,

  //------------------- CAMPAIGN MASTER TEMPLATES --------------------------
  [RedirectPathsEnum.CAMPAIGN_MASTER_TEMPLATES]: () =>
    `${AppRoutesPaths.CAMPAIGN_MASTER_TEMPLATES_ROUTE}`,
  [RedirectPathsEnum.CAMPAIGN_MASTER_TEMPLATES_CREATE]: () =>
    `${AppRoutesPaths.CAMPAIGN_MASTER_TEMPLATES_CREATE_ROUTE}`,
  [RedirectPathsEnum.CAMPAIGN_MASTER_TEMPLATES_EDIT]: (id: string) =>
    processUrl(AppRoutesPaths.CAMPAIGN_MASTER_TEMPLATES_EDIT_ROUTE, { id }),

  //------------------- USER SETTINGS --------------------------
  [RedirectPathsEnum.PROFILE_SETTINGS]: () =>
    `${AppRoutesPaths.PROFILE_SETTINGS_ROUTE}`,
  [RedirectPathsEnum.LEARNER_PROFILE_SETTINGS]: () =>
    `${AppRoutesPaths.LEARNER_PROFILE_SETTINGS_ROUTE}`,

  //------------------- DASHBOARDS --------------------------
  [RedirectPathsEnum.ADMIN_DASHBOARD]: () =>
    `${AppRoutesPaths.ADMIN_DASHBOARD_ROUTE}`,
  [RedirectPathsEnum.LEARNER_DASHBOARD_ACTIVE]: () =>
    `${AppRoutesPaths.LEARNER_DASHBOARD_ACTIVE_ROUTE}`,
  [RedirectPathsEnum.LEARNER_DASHBOARD_COMPLETED]: () =>
    `${AppRoutesPaths.LEARNER_DASHBOARD_COMPLETED_ROUTE}`,
  [RedirectPathsEnum.LEARNER_DASHBOARD_MATERIALS_RESOURCES]: () =>
    `${AppRoutesPaths.LEARNER_DASHBOARD_MATERIALS_RESOURCES_ROUTE}`,
  [RedirectPathsEnum.LEARNER_DASHBOARD_MATERIALS_TODO]: () =>
    `${AppRoutesPaths.LEARNER_DASHBOARD_MATERIALS_TODO_ROUTE}`,
  [RedirectPathsEnum.LEARNER_DASHBOARD_MATERIALS_COMPLETED]: () =>
    `${AppRoutesPaths.LEARNER_DASHBOARD_MATERIALS_COMPLETED_ROUTE}`,
  [RedirectPathsEnum.LEARNER_PHISHING]: () =>
    `${AppRoutesPaths.LEARNER_PHISHING_ROUTE}`,
  [RedirectPathsEnum.LEARNER_PHISHING_DETAIL]: (campaignId: string) =>
    processUrl(AppRoutesPaths.LEARNER_PHISHING_DETAIL_ROUTE, { campaignId }),
  // ------------------- ADMIN TASKS --------------------------
  [RedirectPathsEnum.ADMIN_TASKS]: () => `${AppRoutesPaths.ADMIN_TASKS_ROUTE}`,
  //------------------- NOT FOUND --------------------------
  [RedirectPathsEnum.NOT_FOUND]: () => `${AppRoutesPaths.NOT_FOUND_ROUTE}`,

  // ------------------- UNAUTHORIZED --------------------------
  [RedirectPathsEnum.UNAUTHORIZED]: () =>
    `${AppRoutesPaths.UNAUTHORIZED_ROUTE}`,

  // ------------------- LOGIN --------------------------
  [RedirectPathsEnum.LOGIN]: () => `${AppRoutesPaths.LOGIN_ROUTE}`,

  //------------------- SYSTEM EMAILS --------------------------
  [RedirectPathsEnum.SYSTEM_EMAILS_TEMPLATES]: () =>
    `${AppRoutesPaths.SYSTEM_EMAILS_TEMPLATES_ROUTE}`,
  [RedirectPathsEnum.SYSTEM_EMAILS_TEMPLATES_CREATE]: () =>
    `${AppRoutesPaths.SYSTEM_EMAILS_TEMPLATES_CREATE_ROUTE}`,
  [RedirectPathsEnum.SYSTEM_EMAILS_TEMPLATES_EDIT]: (id: string) =>
    processUrl(AppRoutesPaths.SYSTEM_EMAILS_TEMPLATES_EDIT_ROUTE, { id }),
  [RedirectPathsEnum.SYSTEM_EMAILS_TYPES_CONFIGS]: () =>
    `${AppRoutesPaths.SYSTEM_EMAILS_TYPES_CONFIGS_ROUTE}`,
  [RedirectPathsEnum.SYSTEM_EMAILS_SENDING_CONFIGS]: () =>
    `${AppRoutesPaths.SYSTEM_EMAILS_SENDING_CONFIGS_ROUTE}`,
  [RedirectPathsEnum.SYSTEM_EMAILS_TYPES_CONFIGS_CREATE]: () =>
    `${AppRoutesPaths.SYSTEM_EMAILS_TYPES_CONFIGS_CREATE_ROUTE}`,
  [RedirectPathsEnum.SYSTEM_EMAILS_TYPES_CONFIGS_EDIT]: (id: string) =>
    processUrl(AppRoutesPaths.SYSTEM_EMAILS_TYPES_CONFIGS_EDIT_ROUTE, { id }),

  // ------------------- COURSES --------------------------
  [RedirectPathsEnum.COURSES]: () => `${AppRoutesPaths.COURSES_ROUTE}`,
  [RedirectPathsEnum.CONTENT_ANALYTICS]: () =>
    AppRoutesPaths.CONTENT_ANALYTICS_ROUTE,
  [RedirectPathsEnum.COURSES_CREATE]: (id?: string) => {
    if (id) {
      return processUrl(AppRoutesPaths.COURSES_CREATE_ROUTE, { id });
    }

    return AppRoutesPaths.COURSES_CREATE_BLANK_ROUTE;
  },
  [RedirectPathsEnum.COURSES_CONTENT]: (id: string) =>
    processUrl(AppRoutesPaths.COURSES_CONTENT_ROUTE, { id }),
  [RedirectPathsEnum.COURSES_SCHEDULE]: (id: string) =>
    processUrl(AppRoutesPaths.COURSES_SCHEDULE_ROUTE, { id }),
  [RedirectPathsEnum.COURSES_ACCOUNTS]: (id: string) =>
    processUrl(AppRoutesPaths.COURSES_ACCOUNTS_ROUTE, { id }),
  [RedirectPathsEnum.COURSES_BRANCHES]: (id: string) =>
    processUrl(AppRoutesPaths.COURSES_BRANCHES_ROUTE, { id }),
  [RedirectPathsEnum.COURSES_GROUPS]: (id: string) =>
    processUrl(AppRoutesPaths.COURSES_GROUPS_ROUTE, { id }),
  [RedirectPathsEnum.COURSES_USERS]: (id: string) =>
    processUrl(AppRoutesPaths.COURSES_USERS_ROUTE, { id }),
  [RedirectPathsEnum.COURSES_SCORM_PREVIEW]: (id: string) =>
    processUrl(AppRoutesPaths.COURSES_SCORM_PREVIEW_ROUTE, { id }),
  [RedirectPathsEnum.COURSES_ANALYTICS]: (id: string) =>
    processUrl(AppRoutesPaths.COURSES_ANALYTICS_ROUTE, { id }),
  [RedirectPathsEnum.COURSES_RESULTS]: (courseId: string, quizId: string) =>
    processUrl(AppRoutesPaths.COURSES_RESULTS_ROUTE, { courseId, quizId }),
  [RedirectPathsEnum.COURSES_CHANGES]: (id: string) =>
    processUrl(AppRoutesPaths.COURSES_CHANGES_ROUTE, { id }),
  [RedirectPathsEnum.COURSES_CUSTOMIZE]: (id: string) =>
    processUrl(AppRoutesPaths.COURSES_CUSTOMIZE_ROUTE, { id }),
  [RedirectPathsEnum.COURSES_TRANSLATE]: (id: string) =>
    processUrl(AppRoutesPaths.COURSES_TRANSLATE_ROUTE, { id }),
  [RedirectPathsEnum.COURSES_REPLACE_SCHEDULED_CONTENT]: (
    customizedCourseId: string,
  ) =>
    processUrl(AppRoutesPaths.COURSES_REPLACE_SCHEDULED_CONTENT_ROUTE, {
      customizedCourseId,
    }),

  [RedirectPathsEnum.ACCOUNT_COURSE_SCHEDULE]: () =>
    `${AppRoutesPaths.ACCOUNT_COURSE_EVENT_LOG}`,
  [RedirectPathsEnum.ACCOUNT_COURSE_PLANNER]: () =>
    `${AppRoutesPaths.ACCOUNT_COURSE_PLANNER_ROUTE}`,

  // ------------------- MATERIALS --------------------------
  [RedirectPathsEnum.RESOURCES]: () => `${AppRoutesPaths.RESOURCES_ROUTE}`,
  [RedirectPathsEnum.RESOURCES_CREATE]: () =>
    `${AppRoutesPaths.RESOURCES_CREATE_ROUTE}`,
  [RedirectPathsEnum.RESOURCES_EDIT]: (id: string) =>
    processUrl(AppRoutesPaths.RESOURCES_EDIT_ROUTE, { id }),
  [RedirectPathsEnum.RESOURCES_SCHEDULE]: (id: string) =>
    processUrl(AppRoutesPaths.RESOURCES_SCHEDULE_ROUTE, { id }),
  [RedirectPathsEnum.RESOURCES_ACCOUNTS]: (id: string) =>
    processUrl(AppRoutesPaths.RESOURCES_ACCOUNTS_ROUTE, { id }),
  [RedirectPathsEnum.RESOURCES_USERS]: (id: string) =>
    processUrl(AppRoutesPaths.RESOURCES_USERS_ROUTE, { id }),
  [RedirectPathsEnum.CUSTOM_MATERIALS_EDIT]: (id: string) =>
    processUrl(AppRoutesPaths.CUSTOM_MATERIALS_EDIT_ROUTE, { id }),
  [RedirectPathsEnum.CUSTOM_MATERIALS_SCHEDULE]: (id: string) =>
    processUrl(AppRoutesPaths.CUSTOM_MATERIALS_SCHEDULE_ROUTE, { id }),
  [RedirectPathsEnum.CUSTOM_MATERIALS_USERS]: (id: string) =>
    processUrl(AppRoutesPaths.CUSTOM_MATERIALS_USERS_ROUTE, { id }),
  [RedirectPathsEnum.CUSTOM_MATERIALS_PREVIEW]: (id: string) =>
    processUrl(AppRoutesPaths.CUSTOM_MATERIALS_PREVIEW_ROUTE, { id }),
  [RedirectPathsEnum.MATERIALS_BRANCHES]: (id: string) =>
    processUrl(AppRoutesPaths.MATERIALS_BRANCHES_ROUTE, { id }),
  [RedirectPathsEnum.MATERIALS_GROUPS]: (id: string) =>
    processUrl(AppRoutesPaths.MATERIALS_GROUPS_ROUTE, { id }),
  [RedirectPathsEnum.POSTERS]: () => `${AppRoutesPaths.POSTERS_ROUTE}`,
  [RedirectPathsEnum.POSTERS_COURSE]: () =>
    `${AppRoutesPaths.POSTERS_COURSE_ROUTE}`,
  [RedirectPathsEnum.POSTERS_CYBERSECURITY]: () =>
    `${AppRoutesPaths.POSTERS_CYBERSECURITY_ROUTE}`,
  [RedirectPathsEnum.POSTERS_GDPR]: () =>
    `${AppRoutesPaths.POSTERS_GDPR_ROUTE}`,
  [RedirectPathsEnum.POSTERS_INFOGRAPHICS]: () =>
    `${AppRoutesPaths.POSTERS_INFOGRAPHICS_ROUTE}`,
  [RedirectPathsEnum.POSTERS_INFO_SCREEN]: () =>
    `${AppRoutesPaths.POSTERS_INFO_SCREEN_ROUTE}`,
  [RedirectPathsEnum.POSTER_CREATE]: () =>
    `${AppRoutesPaths.POSTER_CREATE_ROUTE}`,
  [RedirectPathsEnum.POSTER_EDIT]: (id: string) =>
    processUrl(AppRoutesPaths.POSTER_EDIT_ROUTE, { id }),
  [RedirectPathsEnum.POSTER_ACCOUNTS]: (id: string) =>
    processUrl(AppRoutesPaths.POSTER_ACCOUNTS_ROUTE, { id }),

  [RedirectPathsEnum.ACCOUNT_DOCUMENTS_SCHEDULE]: () =>
    `${AppRoutesPaths.ACCOUNT_DOCUMENTS_SCHEDULE_ROUTE}`,

  [RedirectPathsEnum.DOCUMENT_VIEW]: (id: string, attemptId: string) =>
    processUrl(AppRoutesPaths.DOCUMENT_VIEW_ROUTE, { id, attemptId }),

  // ------------------- SCORM COURSES ---------------------------------
  [RedirectPathsEnum.COURSE_INFO]: (id: string) =>
    processUrl(AppRoutesPaths.COURSE_INFO_ROUTE, { id }),
  [RedirectPathsEnum.COURSE_PLAY]: (id: string, attemptId: string) =>
    processUrl(AppRoutesPaths.COURSE_PLAY_ROUTE, { id, attemptId }),
  [RedirectPathsEnum.CONTENT_INFO]: (id: string) =>
    processUrl(AppRoutesPaths.CONTENT_INFO_ROUTE, { id }),
  [RedirectPathsEnum.CONTENT_PLAY]: (id: string, attemptId: string) =>
    processUrl(AppRoutesPaths.CONTENT_PLAY_ROUTE, { id, attemptId }),

  // ------------------- SECURITY CULTURE ---------------------------------
  [RedirectPathsEnum.SECURITY_CULTURE]: () =>
    AppRoutesPaths.SECURITY_CULTURE_ROUTE,
  [RedirectPathsEnum.SURVEY]: () => AppRoutesPaths.SURVEY_ROUTE,
  [RedirectPathsEnum.TAKE_SURVEY]: (surveyId: string, token?: string) =>
    processUrl(AppRoutesPaths.TAKE_SURVEY_ROUTE, { surveyId, token }),
  [RedirectPathsEnum.SECURITY_CULTURE_SEND_SURVEY]: () =>
    AppRoutesPaths.SECURITY_CULTURE_SEND_SURVEY_ROUTE,
  [RedirectPathsEnum.SECURITY_CULTURE_SEND_SURVEY_V2]: () =>
    AppRoutesPaths.SECURITY_CULTURE_SEND_SURVEY_V2_ROUTE,
  [RedirectPathsEnum.SECURITY_CULTURE_SURVEY_PLANNER]: () =>
    AppRoutesPaths.SECURITY_CULTURE_SURVEY_PLANNER_ROUTE,
  [RedirectPathsEnum.SECURITY_CULTURE_UPLOAD_SURVEY]: () =>
    AppRoutesPaths.SECURITY_CULTURE_UPLOAD_SURVEY_ROUTE,
  [RedirectPathsEnum.SECURITY_CULTURE_EDIT_SURVEY]: (id: string) =>
    processUrl(AppRoutesPaths.SECURITY_CULTURE_EDIT_SURVEY_ROUTE, { id }),
  [RedirectPathsEnum.SECURITY_CULTURE_SURVEY]: (surveyId?: string) =>
    surveyId
      ? processUrl(AppRoutesPaths.SECURITY_CULTURE_SURVEY_ID_ROUTE, {
          surveyId,
        })
      : AppRoutesPaths.SECURITY_CULTURE_SURVEY_ROUTE,
  [RedirectPathsEnum.SECURITY_CULTURE_FEEDBACK]: (surveyId: string) =>
    processUrl(AppRoutesPaths.SECURITY_CULTURE_FEEDBACK_ROUTE, {
      surveyId,
    }),
  [RedirectPathsEnum.SECURITY_CULTURE_CATEGORY]: (
    surveyId: string,
    categoryName: string,
  ) =>
    processUrl(AppRoutesPaths.SECURITY_CULTURE_CATEGORY_ROUTE, {
      surveyId,
      categoryName,
    }),

  // ------------------- REPORTS ---------------------------------
  [RedirectPathsEnum.REPORTS_SUMMARY]: () =>
    AppRoutesPaths.REPORTS_SUMMARY_ROUTE,
  [RedirectPathsEnum.REPORTS_AWARENESS]: () =>
    AppRoutesPaths.REPORTS_AWARENESS_ROUTE,

  // ------------------- FEATURE FLAGS ---------------------------------
  [RedirectPathsEnum.FEATURES]: () => AppRoutesPaths.FEATURES_ROUTE,

  // ------------------- LOGIN/LOGOUT ---------------------------------
  [RedirectPathsEnum.LOGOUT]: () => `${AppRoutesPaths.LOGOUT}`,
};

export const CATALOGUE_READ_ONLY_PREVIEW_PARAM = 'preview';
